import React from "react";
import {Modal, Spinner} from "react-bootstrap";

class LoadingModal extends React.Component {

    render(){
        return (
            <Modal
                contentClassName='loadingModal'
                show={this.props.show}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <h4>Cargando... <Spinner animation="grow" variant="primary" /></h4>
            </Modal>
        );
    }
}

export default LoadingModal;
